var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaisIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:rgba(0,0,0,0);}.b{fill:#fff;}.c{clip-path:url(#c);}.d{fill:#00258e;}.e{opacity:0.3;fill:url(#d);}.f{fill:#4675ce;}.g{fill:url(#e);}.h{fill:url(#f);}.i{fill:url(#g);}.j{fill:url(#h);}.k{fill:url(#i);}.l{fill:url(#j);}.m{fill:url(#k);}.n{fill:#e5ac8f;}.o{fill:#bc021d;}.p{fill:url(#m);}.q{fill:url(#n);}.r{fill:url(#o);}.s{fill:url(#p);}.t{fill:url(#q);}.u{fill:url(#r);}.v{fill:#c5a49d;}.w{fill:#ac8d84;}.x{fill:url(#s);}.y{fill:url(#t);}.z{fill:url(#u);}.aa{fill:url(#v);}.ab{fill:url(#w);}.ac{fill:url(#x);}.ad{fill:url(#y);}.ae{fill:url(#z);}.af{fill:#d3967a;}.ag{fill:#ffe6d2;}.ah{fill:url(#aa);}.ai{fill:url(#ab);}.aj{fill:url(#ac);}.ak{fill:url(#ad);}.al{fill:url(#ae);}.am{fill:url(#af);}.an{fill:url(#ag);}.ao{fill:url(#ah);}.ap{fill:url(#ai);}.aq{fill:url(#aj);}.ar{fill:url(#ak);}.as{fill:url(#al);}.at{fill:url(#am);}.au{fill:url(#an);}.av{fill:url(#ao);}.aw{fill:url(#ap);}.ax{fill:url(#aq);}.ay{fill:url(#ar);}.az{fill:url(#as);}.ba{fill:url(#at);}.bb{fill:url(#au);}.bc{fill:url(#av);}.bd{fill:url(#aw);}.be{fill:url(#ax);}.bf{fill:url(#ay);}.bg{fill:url(#az);}.bh{fill:url(#ba);}.bi{fill:url(#bb);}.bj{fill:#943b21;}.bk{fill:url(#bc);}.bl{fill:url(#bd);}.bm{fill:#5e2614;}.bn{fill:url(#be);}.bo{fill:url(#bf);}.bp{fill:url(#bg);}.bq{fill:#7b3b27;}.br{fill:url(#bh);}.bs{fill:url(#bi);}.bt{fill:url(#bj);}.bu{fill:url(#bk);}.bv{fill:url(#bl);}.bw{fill:url(#bm);}.bx{fill:#e75062;}.by{fill:#cb3e44;}.bz{fill:url(#bn);}.ca{fill:#ae261c;}.cb{fill:#ad0223;}.cc{fill:#c18063;}.cd{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 0,
    width: 94,
    height: 94,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.549
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 33,
    cy: 33,
    r: 33
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.5,
    y1: -0.004,
    x2: 0.5,
    y2: 0.996,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcbcbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.5,
    y1: 1.004,
    x2: 0.5,
    y2: 0.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2c499d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3d65bc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0.5,
    cy: 0.491,
    r: 0.07,
    gradientTransform: "matrix(-1.607, 0, 0, 6.48, 1.303, -2.693)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272425",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0.334,
    cy: 0.5,
    r: 0.113,
    gradientTransform: "matrix(0, -1, -4.034, 0, 2.351, 0.834)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0.5,
    cy: 0.618,
    r: 0.126,
    gradientTransform: "matrix(1.345, 0, 0, -3.45, -0.173, 2.75)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-1, 0, 0, 1, 1, 0)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-1, 0, 0, 1, 1, 0)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientTransform: "matrix(-1, 0, 0, 1, 1, 0)",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.5,
    y1: 0.738,
    x2: 0.5,
    y2: -0.243,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5c2a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d67a61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 0.5,
    y1: 1.329,
    x2: 0.5,
    y2: -0.186,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0.958,
    y1: 0.834,
    x2: -0.164,
    y2: -0.35,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 0.881,
    y1: 1.331,
    x2: 0.483,
    y2: 0.408,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: -2.366,
    y1: -1.15,
    x2: -4.285,
    y2: -2.411,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 12.333,
    cy: -14.774,
    r: 0.859,
    gradientTransform: "matrix(-0.65, -0.059, -0.022, 0.586, 19.556, -5.327)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe6d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e5ac8f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: -558.483,
    cy: 473.966,
    r: 0.335,
    gradientTransform: "matrix(-2.713, 0.24, 1.085, 1.57, -2244.535, 1158.569)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9e92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5ac8f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: -86.268,
    cy: -24.476,
    r: 0.367,
    gradientTransform: "matrix(-0.884, -0.609, -1.06, 1.238, -176.225, -63.931)",
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 0.748,
    y1: 1.06,
    x2: 0.248,
    y2: 0.064,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 1.094,
    y1: -0.335,
    x2: 0.153,
    y2: 1.241,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 0.201,
    y1: 1.001,
    x2: 1.522,
    y2: -1.211,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 1.016,
    y1: 1.094,
    x2: 0.072,
    y2: -0.189,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5c2a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1886a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 1.065,
    y1: 1.321,
    x2: 0.347,
    y2: 0.219,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 0.504,
    y1: 0.198,
    x2: 0.504,
    y2: 0.734,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5ac8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8b39c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 0.499,
    y1: 1.677,
    x2: 0.499,
    y2: 1.472,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 0.501,
    y1: 1.676,
    x2: 0.501,
    y2: 1.472,
    xlinkHref: "#m"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 0.5,
    y1: 1.29,
    x2: 0.5,
    y2: 0.15,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e5ac8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1886a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 0.501,
    y1: -0.042,
    x2: 0.501,
    y2: 0.683,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5c2a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ba523b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: -8.11,
    y1: -36.567,
    x2: -8.103,
    y2: -36.75,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e2614"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#612715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#692a17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#78301a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#8c381f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#943b21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "af",
    x1: -351.385,
    y1: -7.638,
    x2: -351.376,
    y2: -7.833,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: 0.673,
    y1: 0.5,
    x2: 0.24,
    y2: 0.54,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#400000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d1200"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ah",
    x1: 0.504,
    y1: 1.495,
    x2: 0.504,
    y2: 1.584,
    xlinkHref: "#ag"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ai",
    x1: 0.674,
    y1: 0.5,
    x2: -0.056,
    y2: 0.5,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    x1: -4.279,
    y1: -3.054,
    x2: -5.213,
    y2: -3.72,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#943b21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c76e5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ak",
    x1: 0.343,
    y1: 0.49,
    x2: 0.796,
    y2: 0.715,
    xlinkHref: "#ag"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 0.783,
    y1: 0.415,
    x2: 0.534,
    y2: 0.629,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "am",
    x1: 0.79,
    y1: 0.094,
    x2: 0.586,
    y2: 0.438,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "an",
    x1: 0.586,
    y1: 0.279,
    x2: 0.5,
    y2: 0.536,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ao",
    x1: 0.581,
    y1: 0.298,
    x2: 0.337,
    y2: 0.566,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ap",
    x1: 0.5,
    y1: 0.192,
    x2: 0.5,
    y2: 0.766,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aq",
    x1: 0.248,
    y1: 0.328,
    x2: 0.861,
    y2: 0.82,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ar",
    x1: 0.093,
    y1: 0.581,
    x2: 0.77,
    y2: 0.487,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "as",
    x1: -0.348,
    y1: 0.167,
    x2: 0.525,
    y2: 0.53,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "at",
    x1: 0.781,
    y1: 0.182,
    x2: 0.575,
    y2: 0.49,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "au",
    x1: 0.895,
    y1: 0.15,
    x2: 0.383,
    y2: 0.711,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "av",
    x1: 0.805,
    y1: 0.106,
    x2: 0.384,
    y2: 0.724,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aw",
    x1: 0.88,
    y1: 0.145,
    x2: 0.389,
    y2: 0.717,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ax",
    x1: 0.872,
    y1: 0.179,
    x2: 0.347,
    y2: 0.713,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ay",
    x1: 1.703,
    y1: 0.233,
    x2: -0.772,
    y2: 0.638,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "az",
    x1: 0.974,
    y1: 0.178,
    x2: 0.288,
    y2: 0.684,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: 0.662,
    y1: 0.15,
    x2: 0.485,
    y2: 0.528,
    xlinkHref: "#ag"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb",
    x1: 0.576,
    y1: 0.145,
    x2: 0.385,
    y2: 0.54,
    xlinkHref: "#ag"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc",
    x1: 0.5,
    y1: 0.923,
    x2: 0.5,
    y2: 0.209,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bd",
    x1: 0.367,
    y1: -0.666,
    x2: 0.591,
    y2: 1.236,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: 0.513,
    y1: 0.039,
    x2: 0.358,
    y2: 0.629,
    xlinkHref: "#ag"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bf",
    x1: 0.5,
    y1: 1.383,
    x2: 0.5,
    y2: -0.284,
    xlinkHref: "#aj"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0.565,
    y1: 0.093,
    x2: 0.193,
    y2: 0.703,
    xlinkHref: "#ae"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bh",
    x1: -13.295,
    y1: -19.866,
    x2: -13.295,
    y2: -20.627,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39140a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi",
    x1: -15.081,
    y1: -21.324,
    x2: -15.081,
    y2: -22.141,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#652312"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#210000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bj",
    x1: -36.878,
    y1: -49.421,
    x2: -36.878,
    y2: -48.944,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77726d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bk",
    x1: -14.24,
    y1: -19.7,
    x2: -14.24,
    y2: -20.457,
    xlinkHref: "#bh"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bl",
    x1: -16.023,
    y1: -21.153,
    x2: -16.023,
    y2: -21.966,
    xlinkHref: "#bi"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bm",
    x1: -39.677,
    y1: -52.101,
    x2: -39.677,
    y2: -51.597,
    xlinkHref: "#bj"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "bn",
    cx: 370.254,
    cy: -1122.424,
    r: 2.52,
    gradientTransform: "matrix(-0.2, -0.077, -0.015, 0.997, 212.783, -6.692)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff979a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e75062"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 11)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cd",
    transform: "matrix(1, 0, 0, 1, -11, -11)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35,0A35,35,0,1,0,70,35,35,35,0,0,0,35,0Z",
    transform: "translate(11 11)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 67.776,
    height: 67.776,
    transform: "translate(-1.063 -0.579)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M6.464,8.567H5.488V8.152h.975A2.461,2.461,0,0,1,8.925,10.61V23.478a.83.83,0,0,1,.573.573h2.848A2.038,2.038,0,0,0,14.384,22V0H14.8V22a2.466,2.466,0,0,1-2.461,2.461H9.49a.83.83,0,0,1-.573.573v6.044a.83.83,0,0,1,.573.573h2.848A2.466,2.466,0,0,1,14.8,34.112v3.441a2.466,2.466,0,0,1-2.461,2.461H9.49a.83.83,0,0,1-.573.573v2.619a2.466,2.466,0,0,1-2.461,2.461H5.48v-.415h.975a2.038,2.038,0,0,0,2.038-2.038V40.588a.83.83,0,0,1-.573-.573H5.48V39.6H7.921a.83.83,0,0,1,.581-.581V32.647a.83.83,0,0,1-.573-.573H5.488v-.415H7.929a.83.83,0,0,1,.573-.573V25.022a.83.83,0,0,1-.573-.573H5.488v-.415H7.929a.83.83,0,0,1,.573-.573V10.593A2.038,2.038,0,0,0,6.464,8.567ZM8.925,39.019a.83.83,0,0,1,.573.573h2.848a2.038,2.038,0,0,0,2.038-2.038V34.112a2.038,2.038,0,0,0-2.038-2.038H9.5a.83.83,0,0,1-.573.573Zm-3.059,13H5.488V51.6h.378a2.466,2.466,0,0,1,2.461,2.461V64.19a.963.963,0,0,1,.726.722h6.3a1.141,1.141,0,0,1,.9-.9V46.021a2.466,2.466,0,0,1,2.461-2.461h3.142a.635.635,0,0,1,.415-.415V19.372a2.491,2.491,0,0,1,2.466-2.461H25.8a.884.884,0,0,1,.648-.648V0h.415V16.263a.884.884,0,0,1,.648.648h3.4a.88.88,0,0,1,.76-.668V5.774a2.466,2.466,0,0,1,2.474-2.453h13.7a.872.872,0,0,1,.631-.627V0h.415V2.686a.863.863,0,0,1,.623.635h3.321a.9.9,0,0,1,.668-.668V0h.415V2.644a.9.9,0,0,1,.672.677H73.264v.415H54.585a.909.909,0,0,1-.672.672V7.057a.8.8,0,0,1,.556.556H68.636A2.466,2.466,0,0,1,71.1,10.074v6.832a.83.83,0,0,1,.577.573h1.59v.415h-1.59a.83.83,0,0,1-.577.573v3.761a2.466,2.466,0,0,1-2.461,2.461H58.881a1.4,1.4,0,0,1-1.191,1.187V30.3a.511.511,0,0,1,.27.266h15.3v.415H57.977a.535.535,0,0,1-.27.27v4.259a.955.955,0,0,1,.706.706h7.555a2.461,2.461,0,0,1,2.461,2.461v4.18a.93.93,0,0,1,.706.7h4.13v.415H69.113a.93.93,0,0,1-.706.706v4.6a.772.772,0,0,1,.552.527h4.3v.415h-4.3a.776.776,0,0,1-.531.531V58.9a.955.955,0,0,1,.706.706h4.13v.415H69.113a.955.955,0,0,1-.706.7V67.78h-.415V60.724a.955.955,0,0,1-.7-.7H59.745a2.466,2.466,0,0,1-2.47-2.453V50.512a.511.511,0,0,1-.266-.27h-.527a2.042,2.042,0,0,0-2.03,2.059V67.8h-.415V52.3a2.466,2.466,0,0,1,2.453-2.491h.527a.519.519,0,0,1,.266-.266V44.689a.93.93,0,0,1-.7-.706h-7.3a.639.639,0,0,1-.415.415V57.071A2.466,2.466,0,0,1,46.4,59.532H42.294a.8.8,0,0,1-.56.56v2.785a2.466,2.466,0,0,1-2.461,2.462H24.815a.614.614,0,0,1-.361.365V67.78h-.415V65.7a.61.61,0,0,1-.365-.365H17.6a1.142,1.142,0,0,1-.909.909v1.54h-.415v-1.54a1.142,1.142,0,0,1-.9-.909H9.058a.967.967,0,0,1-.726.726v1.723H7.917V66.066a.967.967,0,0,1-.726-.726H5.5v-.415H7.19a.963.963,0,0,1,.726-.722V54.057a2.042,2.042,0,0,0-2.051-2.038Zm51.824,5.55a2.042,2.042,0,0,0,2.038,2.038H67.3a.955.955,0,0,1,.7-.706V50.774a.78.78,0,0,1-.527-.548h-9.5a.535.535,0,0,1-.27.27Zm0-8.015a.544.544,0,0,1,.27.266h9.518a.772.772,0,0,1,.527-.527v-4.6a.93.93,0,0,1-.7-.706H58.412a.942.942,0,0,1-.706.706Zm0-6.7a.942.942,0,0,1,.706.7H67.3a.93.93,0,0,1,.7-.7v-4.18a2.038,2.038,0,0,0-2.038-2.038H58.412a.955.955,0,0,1-.722.718Zm0-19.754a1.4,1.4,0,0,1,1.175,1.175h9.771a2.038,2.038,0,0,0,2.038-2.038V18.48a.83.83,0,0,1-.573-.573H59.745a2.038,2.038,0,0,0-2.055,2.038Zm2.055-5.624H70.1a.83.83,0,0,1,.573-.573V10.07a2.038,2.038,0,0,0-2.038-2.038H54.469a.8.8,0,0,1-.556.552V22.241a2.042,2.042,0,0,0,2.042,2.038h.154A1.4,1.4,0,0,1,57.275,23.1V19.945a2.466,2.466,0,0,1,2.47-2.466ZM48.878,43.169a.639.639,0,0,1,.415.415h7.289a.93.93,0,0,1,.693-.726v-5.5a.942.942,0,0,1-.7-.706H49.28a.656.656,0,0,1-.415.415Zm0-7.347a.656.656,0,0,1,.415.415h7.285a.955.955,0,0,1,.706-.706V31.248a.511.511,0,0,1-.266-.27H49.509a.868.868,0,0,1-.631.631Zm0-5.89a.876.876,0,0,1,.631.631h7.509a.49.49,0,0,1,.257-.262V25.877A1.4,1.4,0,0,1,56.1,24.7h-.154a2.491,2.491,0,0,1-2.466-2.461V8.584a.8.8,0,0,1-.552-.552H49.5a.863.863,0,0,1-.631.627Zm0-22.946a.868.868,0,0,1,.631.631h3.429a.8.8,0,0,1,.552-.56V4.408a.909.909,0,0,1-.668-.672H49.5a.868.868,0,0,1-.631.631Zm-22.415,11a.88.88,0,0,1-.648-.643H24.753a2.042,2.042,0,0,0-2.042,2.038V43.169a.639.639,0,0,1,.415.415H25.9a.83.83,0,0,1,.577-.573Zm0,26.566a.83.83,0,0,1-.577-.577H23.113a.639.639,0,0,1-.415.415v2.125a1.88,1.88,0,1,0,3.736,0Zm22-40.193a.876.876,0,0,1-.639-.623h-13.7a2.038,2.038,0,0,0-2.038,2.038V16.3a.88.88,0,0,1,.535.61H41a.577.577,0,0,1,.32-.32V10.07a2.466,2.466,0,0,1,2.461-2.461h4.039a.876.876,0,0,1,.631-.631ZM32.112,17.936v7.1a2.042,2.042,0,0,0,2.038,2.038H41a.577.577,0,0,1,.32-.32V17.65a.556.556,0,0,1-.32-.315H32.639a.9.9,0,0,1-.535.61ZM48.454,8.659a.872.872,0,0,1-.631-.627H43.785a2.038,2.038,0,0,0-2.038,2.038V16.6a.577.577,0,0,1,.32.32h.266a2.466,2.466,0,0,1,2.461,2.461v5.654A2.466,2.466,0,0,1,42.332,27.5h-.27a.577.577,0,0,1-.32.32v.7a2.038,2.038,0,0,0,2.038,2.038h4.043a.884.884,0,0,1,.631-.631ZM41.746,17.65v9.107a.577.577,0,0,1,.32.32h.266a2.046,2.046,0,0,0,2.038-2.038V19.372a2.042,2.042,0,0,0-2.038-2.038h-.27A.556.556,0,0,1,41.746,17.65Zm6.708,13.959a.876.876,0,0,1-.631-.631H43.785a2.466,2.466,0,0,1-2.461-2.461v-.706a.577.577,0,0,1-.32-.32H34.142a2.466,2.466,0,0,1-2.461-2.461V17.973a.88.88,0,0,1-.76-.664h-3.4a.88.88,0,0,1-.648.643V42.962a.83.83,0,0,1,.577.573H32.4a.631.631,0,0,1,.415-.415V38.678a2.466,2.466,0,0,1,2.457-2.461H48.052a.668.668,0,0,1,.415-.415Zm0,5.434a.668.668,0,0,1-.415-.415H35.275a2.038,2.038,0,0,0-2.038,2.038v4.5a.635.635,0,0,1,.415.415h14.4a.652.652,0,0,1,.415-.415ZM41.746,58.528a.8.8,0,0,1,.56.56h4.109a2.038,2.038,0,0,0,2.038-2.038V44.386a.648.648,0,0,1-.415-.415H33.615a.631.631,0,0,1-.415.415V51.23a1.245,1.245,0,0,1,1,1h5.081A2.466,2.466,0,0,1,41.746,54.7Zm-8.518-4.873v3.4A2.038,2.038,0,0,0,35.275,59.1h5.488a.8.8,0,0,1,.56-.569v-3.84a2.038,2.038,0,0,0-2.038-2.038H34.233a1.245,1.245,0,0,1-1,1.013ZM24.483,64.538a.627.627,0,0,1,.361.365H39.285a2.038,2.038,0,0,0,2.038-2.038V60.08a.8.8,0,0,1-.56-.56H35.275a2.466,2.466,0,0,1-2.461-2.461v-3.4a1.245,1.245,0,0,1-1-1h-5.3A2.038,2.038,0,0,0,24.475,54.7ZM16.717,64a1.142,1.142,0,0,1,.909.9h6.052a.623.623,0,0,1,.365-.365V54.7A2.461,2.461,0,0,1,26.5,52.235h5.3a1.245,1.245,0,0,1,1-1V44.386a.627.627,0,0,1-.415-.415H27.442a.83.83,0,0,1-.577.577V46.5a2.461,2.461,0,0,1-2.134,2.441H24.4A2.466,2.466,0,0,1,22.266,46.5V44.373a.631.631,0,0,1-.415-.415H18.709A2.046,2.046,0,0,0,16.671,46Z",
    transform: "translate(-6.552 -0.579)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M62.68,41.33a.535.535,0,1,1-.381.155A.54.54,0,0,1,62.68,41.33Z",
    transform: "translate(-20.026 -24.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M95.855,103.941a.535.535,0,1,1,.535-.535A.535.535,0,0,1,95.855,103.941Zm0-.83a.282.282,0,1,0,.282.282.282.282,0,0,0-.282-.282Z",
    transform: "translate(-66.97 -60.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M95.864,100.159a.54.54,0,1,1,.535-.54.54.54,0,0,1-.535.54Zm0-.83a.282.282,0,1,0,.282.282.282.282,0,0,0-.282-.282Z",
    transform: "translate(-66.978 -58.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M95.864,96.379a.54.54,0,1,1,.535-.535A.54.54,0,0,1,95.864,96.379Z",
    transform: "translate(-66.978 -56.321)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M95.855,92.611a.535.535,0,1,1,.535-.535A.535.535,0,0,1,95.855,92.611Z",
    transform: "translate(-66.97 -54.122)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M95.864,88.829a.54.54,0,1,1,.535-.54.539.539,0,0,1-.535.54Z",
    transform: "translate(-66.978 -51.905)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M95.864,85.049a.54.54,0,1,1,.535-.535A.54.54,0,0,1,95.864,85.049Z",
    transform: "translate(-66.978 -49.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M62.68,37.55a.54.54,0,1,1-.54.54A.54.54,0,0,1,62.68,37.55Z",
    transform: "translate(-20.025 -22.542)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M62.685,34.851a.535.535,0,1,1,.535-.535A.535.535,0,0,1,62.685,34.851Z",
    transform: "translate(-20.031 -20.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M38.16,110.234a.54.54,0,1,1,.54.535.54.54,0,0,1-.54-.535Zm.83,0a.286.286,0,1,0-.284.252A.286.286,0,0,0,38.99,110.234Z",
    transform: "translate(13.908 -64.738)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 0.535,
    cy: 0.535,
    rx: 0.535,
    ry: 0.535,
    transform: "translate(53.637 44.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M30.62,110.245a.535.535,0,1,1,.535.535A.535.535,0,0,1,30.62,110.245Zm.83,0a.276.276,0,1,1-.012,0Z",
    transform: "translate(24.586 -64.749)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "f",
    cx: 0.535,
    cy: 0.535,
    rx: 0.535,
    ry: 0.535,
    transform: "translate(56.776 44.973)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M23.05,110.234a.54.54,0,1,1,.535.535.54.54,0,0,1-.535-.535Zm.83,0a.28.28,0,1,0-.278.282.282.282,0,0,0,.278-.282Z",
    transform: "translate(35.29 -64.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M5.509,6.442V3.429A1.773,1.773,0,0,1,6.24,3.2V0h.253V3.2a1.735,1.735,0,0,1,1.615,1.59H18.344a1.108,1.108,0,0,1,.975-.963V0h.253V3.831a1.117,1.117,0,0,1,.975.963h8.717a.635.635,0,0,1,.494-.49V0h.253V4.3a.631.631,0,0,1,.494.49h2.843a.623.623,0,0,1,.473-.465V0h.228V4.329a.614.614,0,0,1,.473.465h14.57a1.121,1.121,0,0,1,.975-.963V0h.253V3.831a1.117,1.117,0,0,1,.98.963h3.267a1.59,1.59,0,0,1,1.59,1.59v3.935a1.59,1.59,0,0,1-1.59,1.594H50.808a.627.627,0,0,1-.486.486v5.927a1.594,1.594,0,0,1-1.59,1.6h-8.87a.486.486,0,0,1-.336.34V32.423a1.59,1.59,0,0,1-1.59,1.59H34.051V48.761H42.39a1.021,1.021,0,0,1,.884-.884v-5.06a1.594,1.594,0,0,1,1.569-1.59h6.011a.573.573,0,0,1,.415-.415V28.961a1.594,1.594,0,0,1,1.594-1.59h2.6a.585.585,0,0,1,.444-.444V20.676a1.59,1.59,0,0,1,1.59-1.581H59.6a.515.515,0,0,1,.378-.378V11.029a1.594,1.594,0,0,1,1.59-1.59H73.285v.253H61.571a1.341,1.341,0,0,0-1.337,1.337v7.679a.515.515,0,0,1,.382.386h4.819a1.586,1.586,0,0,1,1.59,1.59v6a.83.83,0,0,1,.689.689h5.571v.253H67.715a.83.83,0,0,1-.689.689v4.109a1.337,1.337,0,0,0,1.337,1.337h4.923v.253H68.362a1.59,1.59,0,0,1-1.59-1.59V28.313a.83.83,0,0,1-.689-.689H61.447a1.345,1.345,0,0,1-1.208,1.208V39.89a1.594,1.594,0,0,1-1.59,1.59h-1.98a.668.668,0,0,1-.511.444v3.948A1.341,1.341,0,0,0,57.5,47.208H68.769a1.125,1.125,0,0,1,.992-1v-5.7a1.594,1.594,0,0,1,1.59-1.594h1.934v.257H71.351a1.337,1.337,0,0,0-1.337,1.337v5.7a1.129,1.129,0,0,1,1,1h2.275v.253H70.994a1.125,1.125,0,0,1-1,.992v9.506a1.337,1.337,0,0,0,1.337,1.337h1.951v.257H71.351a1.594,1.594,0,0,1-1.6-1.594V48.449a1.121,1.121,0,0,1-.992-.992H57.5a1.594,1.594,0,0,1-1.59-1.59V41.924a.672.672,0,0,1-.506-.44h-3.42a.585.585,0,0,1-.415.415v6.513a.477.477,0,0,1,.332.332h.776a1.594,1.594,0,0,1,1.59,1.59V51.72a.909.909,0,0,1,.764.764h6.542a1.594,1.594,0,0,1,1.59,1.59v13.7H62.9v-13.7a1.337,1.337,0,0,0-1.332-1.337H55.025a.9.9,0,0,1-.764.764V67.759h-.253V53.518a.9.9,0,0,1-.764-.764h-.365a1.594,1.594,0,0,1-1.594-1.59V49.35a.49.49,0,0,1-.332-.336H44.428a1.021,1.021,0,0,1-.884.888V67.776h-.253V49.9a1.021,1.021,0,0,1-.884-.888H34.051V61.529a1.59,1.59,0,0,1-1.59,1.59H28.48a.926.926,0,0,1-.789.793v3.865h-.253V63.924a.926.926,0,0,1-.789-.793H22.914a1.59,1.59,0,0,1-1.594-1.59V56.066A.465.465,0,0,1,21,55.751H14.716a1.4,1.4,0,0,1-1.27,1.27V67.776h-.257V57.021a1.4,1.4,0,0,1-1.27-1.27H5.845a.652.652,0,0,1-.365.469V55.029a.652.652,0,0,1,.365.469h6.1a1.4,1.4,0,0,1,1.27-1.274V37.836a.648.648,0,0,1-.511-.511H7.821a1.59,1.59,0,0,1-1.581-1.59V24.113a.656.656,0,0,1-.5-.511H5.517v-.253h.224a.648.648,0,0,1,.5-.519v-2.4a.656.656,0,0,1-.5-.511H5.517v-.253h.224a.656.656,0,0,1,.5-.511V6.666a1.714,1.714,0,0,1-.731-.224ZM50.322,11.17a.627.627,0,0,1,.486.486h3.761a1.337,1.337,0,0,0,1.337-1.337V6.384a1.337,1.337,0,0,0-1.337-1.332H51.306a1.112,1.112,0,0,1-.984.988Zm9.912,14.981a1.345,1.345,0,0,1,1.212,1.22h4.637a.83.83,0,0,1,.689-.689V20.676a1.337,1.337,0,0,0-1.337-1.337H60.616a.519.519,0,0,1-.378.378ZM56.158,40.588a.677.677,0,0,1,.544.627h1.943a1.341,1.341,0,0,0,1.337-1.337V28.832a1.345,1.345,0,0,1-1.208-1.208H56.607a.585.585,0,0,1-.448.444Zm0-13.673a.585.585,0,0,1,.448.444h2.167a1.345,1.345,0,0,1,1.208-1.208V19.717a.519.519,0,0,1-.378-.378H57.5a1.337,1.337,0,0,0-1.337,1.337ZM51.543,51.152a1.337,1.337,0,0,0,1.337,1.337h.365a.909.909,0,0,1,.764-.764V50.351a1.341,1.341,0,0,0-1.337-1.337h-.8a.486.486,0,0,1-.332.336Zm0-10.377a.585.585,0,0,1,.415.415h3.4a.677.677,0,0,1,.544-.627V28.068a.585.585,0,0,1-.444-.444H52.879a1.337,1.337,0,0,0-1.337,1.337ZM43.527,47.86a1.021,1.021,0,0,1,.9.9h6.525a.486.486,0,0,1,.332-.332v-6.5a.573.573,0,0,1-.415-.415H44.843a1.337,1.337,0,0,0-1.337,1.337ZM34.059,33.747h3.877a1.337,1.337,0,0,0,1.332-1.337V20.256a.486.486,0,0,1-.336-.34H34.57a.656.656,0,0,1-.519.515Zm0-14.607a.648.648,0,0,1,.511.511h4.363a.486.486,0,0,1,.336-.34V16.678a1.337,1.337,0,0,0-1.332-1.32h-3.52a.5.5,0,0,1-.357.357Zm0-4.421a.5.5,0,0,1,.357.357h3.52a1.594,1.594,0,0,1,1.59,1.59V19.31a.486.486,0,0,1,.336.34h8.87a1.337,1.337,0,0,0,1.337-1.337V12.4a.627.627,0,0,1-.486-.486H34.931a1.013,1.013,0,0,1-.872.872Zm-.008-3.927a1.013,1.013,0,0,1,.872.872H49.583a.627.627,0,0,1,.486-.486V6.04a1.117,1.117,0,0,1-.98-.988H34.561a.614.614,0,0,1-.511.49ZM33.793,5.55a.618.618,0,0,1-.477-.49H30.477a.631.631,0,0,1-.494.49v4.769a1.337,1.337,0,0,0,1.337,1.337h1.606a1,1,0,0,1,.876-.863Zm0,7.243a1,1,0,0,1-.868-.872H31.319a1.594,1.594,0,0,1-1.59-1.594V5.541a.635.635,0,0,1-.494-.49H20.544a1.112,1.112,0,0,1-.98.988v8.692a.5.5,0,0,1,.357.357H33.449a.5.5,0,0,1,.353-.357Zm0,2.906a.5.5,0,0,1-.353-.357h-13.5a.5.5,0,0,1-.357.357v3.454a.648.648,0,0,1,.511.511h13.2a.66.66,0,0,1,.511-.511Zm0,4.732a.668.668,0,0,1-.5-.506H20.083a.656.656,0,0,1-.511.515V22.83a.656.656,0,0,1,.511.515h4.379a1.594,1.594,0,0,1,1.59,1.59V33.4a.5.5,0,0,1,.365.361H33.8ZM19.564,24.113v8.3A1.337,1.337,0,0,0,20.9,33.751h4.524a.5.5,0,0,1,.365-.361V24.939A1.337,1.337,0,0,0,24.454,23.6H20.075a.648.648,0,0,1-.5.511ZM21.6,61.529a1.337,1.337,0,0,0,1.337,1.337H26.67a.926.926,0,0,1,.789-.789V57.1a1.337,1.337,0,0,0-1.337-1.337H21.934a.465.465,0,0,1-.315.315Zm0-6.351a.477.477,0,0,1,.315.32h4.2a1.594,1.594,0,0,1,1.59,1.59v4.981a.926.926,0,0,1,.789.789h3.981A1.337,1.337,0,0,0,33.8,61.521V49.014H22.943A1.337,1.337,0,0,0,21.6,50.351Zm-8.132-.955a1.407,1.407,0,0,1,1.27,1.274h6.3a.477.477,0,0,1,.315-.32V50.351a1.594,1.594,0,0,1,1.594-1.59H33.8V34.013H26.417a.511.511,0,0,1-.365.365v1.357a1.594,1.594,0,0,1-1.59,1.59H13.985a.648.648,0,0,1-.511.511Zm0-17.666a.656.656,0,0,1,.511.515H24.462A1.341,1.341,0,0,0,25.8,35.735V34.378a.511.511,0,0,1-.365-.365H20.909a1.586,1.586,0,0,1-1.59-1.59v-8.3a.656.656,0,0,1-.515-.511H13.985a.648.648,0,0,1-.511.511Zm0-13.723a.656.656,0,0,1,.511.515H18.8a.668.668,0,0,1,.515-.519v-2.4a.668.668,0,0,1-.515-.506H13.985a.656.656,0,0,1-.511.515Zm0-3.682a.648.648,0,0,1,.511.511H18.8a.656.656,0,0,1,.515-.511V15.7a.5.5,0,0,1-.357-.357H14.811a1.337,1.337,0,0,0-1.332,1.337Zm-6.99,16.6a1.337,1.337,0,0,0,1.337,1.337h4.894a.656.656,0,0,1,.511-.515V24.125a.648.648,0,0,1-.511-.511h-5.7a.66.66,0,0,1-.527.515Zm0-12.9A.66.66,0,0,1,7,23.37h5.7a.656.656,0,0,1,.511-.54v-2.4a.656.656,0,0,1-.511-.506h-5.7a.656.656,0,0,1-.527.515Zm0-3.686A.66.66,0,0,1,7,19.684h5.7a.648.648,0,0,1,.511-.511V16.682a1.594,1.594,0,0,1,1.59-1.59h4.151a.5.5,0,0,1,.357-.357V6.04a1.1,1.1,0,0,1-.98-.988H8.1A1.727,1.727,0,0,1,6.48,6.666Z",
    transform: "translate(-6.572 -0.579)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "h",
    cx: 2.922,
    cy: 4.695,
    rx: 2.922,
    ry: 4.695,
    transform: "translate(50.616 28.112)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "i",
    cx: 4.695,
    cy: 2.922,
    rx: 4.695,
    ry: 2.922,
    transform: "translate(17.076 45.388)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "j",
    cx: 2.922,
    cy: 3.931,
    rx: 2.922,
    ry: 3.931,
    transform: "translate(9.937 6.029)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "k",
    cx: 2.972,
    cy: 2.972,
    rx: 2.972,
    ry: 2.972,
    transform: "translate(40.628 1.376)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "l",
    cx: 2.972,
    cy: 2.972,
    rx: 2.972,
    ry: 2.972,
    transform: "translate(9.933 19.947)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "m",
    cx: 2.972,
    cy: 2.972,
    rx: 2.972,
    ry: 2.972,
    transform: "translate(44.576 49.078)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M160.734,148.124a.116.116,0,0,0,.062.12,6.866,6.866,0,0,0,.639,3.736,7.266,7.266,0,0,0,1.374,1.88,52.3,52.3,0,0,0-1.943,4.919,14.337,14.337,0,0,1-1.615,3.736c-.963,1.357-2.146,1.27-3.454,1.42-6.272-3.931-11.535-9.676-17.019-14.69v-.025a16.7,16.7,0,0,0-1.86-2.192c-.091-.108-.2-.241-.307-.378a3.238,3.238,0,0,0,.552-.133c.037,0,0-.062,0-.066l-.83-.17-.83-.2a13.256,13.256,0,0,1-3.848-1.635,22.632,22.632,0,0,1-3.242-2.785,6.332,6.332,0,0,1-.448-.66l-.066-.108a8.867,8.867,0,0,1,1-4.118,8.206,8.206,0,0,1,3.968,1.822c.494.44.959,1.631-.237,1.469a5.527,5.527,0,0,1-1.183-.315,8.745,8.745,0,0,0-1.5-.515.037.037,0,0,0-.025.066,5.732,5.732,0,0,0,3.1,1.245,1.042,1.042,0,0,0,.884-1.469,3.471,3.471,0,0,0-1.3-1.324,2.465,2.465,0,0,0,1.909-.594,1.5,1.5,0,0,0,.149-1.561,1.353,1.353,0,0,0,1.187-.158,1.2,1.2,0,0,0,.519-.98,4.348,4.348,0,0,0,1.162.141c-1.337,1-1.847,3.823-1.457,5.085a.075.075,0,0,0,.141,0c.83-1.876.523-3.964,2.358-5.234a3.174,3.174,0,0,0,.353-.1.087.087,0,0,0,0-.162c-1-.245-2.138-.033-3.084-.469a1.274,1.274,0,0,1-.772-1.461c.764-.133,1.569-.461,2.212-.589a9.432,9.432,0,0,1,3.736-.22c.614,1.515.066,3.707-.228,5.139-.369,1.777-.83,3.528-1.245,5.292l-.1.469.353.3c2.835,2.3,6.006,4.251,9,6.3,1.909,1.308,3.844,2.86,5.878,4.151l.336.208a19.625,19.625,0,0,0,2.731,1.415.054.054,0,0,0,.058-.083,20.589,20.589,0,0,0-2.491-2.2,74.3,74.3,0,0,0,2.1-9.132c.183-1.013.378-2.034.569-3.059a18.442,18.442,0,0,0,5.131,2.03A22.222,22.222,0,0,0,160.734,148.124Z",
    transform: "translate(-147.215 -77.399)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M71.934,211.57l-7.3-2.2s-4.566.261-6.857,3.005-.174,2.491-.174,2.491a2.209,2.209,0,0,0,1.623,3.3s-1.3,2.964.955,1.88c0,0-1.457,1.843.577,1.611,0,0,1.586,3.138,5.67.631,0,0,7.368-2.1,7.4-3.786A28.02,28.02,0,0,0,71.934,211.57Z",
    transform: "translate(-28.374 -123.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M81.671,103.208s-7.057-2.358-7.966-5.869c-1-3.781,1.2-13.428,1.2-13.428L61.771,91.568s.5,5.172-2.906,6.563A32.513,32.513,0,0,1,52,100.024s3.8,7.169,11.261,8.256S76.274,104.287,81.671,103.208Z",
    transform: "translate(-34.268 -49.659)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M55.459,109.62c-1.42-2.163-.3-7.31-.3-7.31l.079.05a18.1,18.1,0,0,0,.075,5.741c.693,2.623,4.8,4.6,6.828,5.438C61.382,113.277,56.758,111.6,55.459,109.62Z",
    transform: "translate(-15.877 -60.421)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M108.176,114.661a4.275,4.275,0,0,0,2.316-2.491,4.377,4.377,0,0,1-2.2,2.756,47.827,47.827,0,0,1-6.268,1.868,21.3,21.3,0,0,0,1.9,3.25,18.007,18.007,0,0,1-2.619-3.5A32.513,32.513,0,0,0,108.176,114.661Z",
    transform: "translate(-83.557 -66.188)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M79.6,90.078c-.693.1-4.176,5.965-7.36,6.264a5.213,5.213,0,0,1-3.935-1.287,10.278,10.278,0,0,0,.357-3.487L81.8,83.91a72.728,72.728,0,0,0-1.328,8.252C80.389,91.5,80.148,90,79.6,90.078Z",
    transform: "translate(-41.164 -49.659)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M117.47,61.778a2.835,2.835,0,0,1-.473-.909.677.677,0,0,0-.83.415,14.271,14.271,0,0,0,.12,2.955s.2,1.034.5,1.245.83-.71.83-.71Z",
    transform: "translate(-96.824 -36.165)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M79.228,41.033a6.974,6.974,0,0,1,1.291-1.44c.5-.3,1.245.2,1.345,1.291a11.111,11.111,0,0,1-.5,3.931A11.616,11.616,0,0,1,78.531,47.4c-.548.149-1.046.249-1.395-.149a15.674,15.674,0,0,1-3.321,5.023c-2.075,1.889-7.393,3.981-9.082,4.28s-3.977.174-4.774-1.714c0,0-1.938-3.508-3.134-5.745a10.306,10.306,0,0,1-1.611-5.774c.1-1.992.892-3.379.747-4.823s-.6-1.59-.5-2.835a14.906,14.906,0,0,1,.735-2.835c.648-1.889.648-3.678,1.494-5.566a13.259,13.259,0,0,1,12.631-6.567c7.31.648,10.842,6.168,11.207,9.6a18.051,18.051,0,0,1-1.66,9.6Z",
    transform: "translate(-35.81 -12.651)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M63.268,28.41a13.027,13.027,0,0,1,6.841-5.786c.635-.025,1.278-.025,1.934,0,7.252.34,12.967,4,12.772,8.169s-6.226,7.272-13.482,6.932a18.4,18.4,0,0,1-9.775-3.055c.066-.22.141-.452.224-.7C62.422,32.088,62.422,30.3,63.268,28.41Z",
    transform: "translate(-41.386 -13.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M76.975,42.374s0-2.835-.519-3.358-.747-2.76-.83-4.7a5.853,5.853,0,0,0-4.242-5.438c-2.985-.83-4.4-.075-5.969.3a6.362,6.362,0,0,1-6.641-1.714,2.32,2.32,0,0,0-2.906.88,9.579,9.579,0,0,1,.415-1.083,13.231,13.231,0,0,1,12.631-6.567c7.31.648,10.842,6.168,11.207,9.6a18.051,18.051,0,0,1-1.66,9.6l-.506.9-.17.249Z",
    transform: "translate(-34.412 -12.651)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M68.913,20.7c7.31.648,10.842,6.168,11.207,9.6a18.051,18.051,0,0,1-1.66,9.6l-.506.9-.1.149c.627-1.361,2.528-6.015,1.9-10.5-.747-5.321-5.471-9.3-11.29-9.7-.448-.029-.83-.062-1.146-.1A13.84,13.84,0,0,1,68.913,20.7Zm-13.038,7.65a.122.122,0,0,1,.033-.1c.033-.033,0-.037,0-.058a.588.588,0,0,0,.029-.091l.025-.066a.1.1,0,0,1,.029-.083c.029-.025.033-.1.054-.145a.322.322,0,0,1,.021-.058l.037-.1.025-.058a.273.273,0,0,1,.046-.108c.017-.033,0-.037,0-.054a1.055,1.055,0,0,1,.071-.158,12.849,12.849,0,0,1,5.973-5.425c-1.635,1.034-4.827,3.321-5.923,5.986a2.906,2.906,0,0,0-.457.523Z",
    transform: "translate(-34.399 -12.655)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M110.923,70.864a17.157,17.157,0,0,1,.589-3.134,6.545,6.545,0,0,1,2.76,4.338c.523,2.387,0,4.62-1.171,5.624-.2-.369-.415-.726-.569-1.054A10.339,10.339,0,0,1,110.923,70.864Z",
    transform: "translate(-91.527 -40.195)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M61.343,79.509c-1.806-1.391-1.507-4.811.672-7.638s5.4-4,7.21-2.607c1.449,1.117,1.54,3.541.415,5.915a1.938,1.938,0,0,1-.527.32c-.548.149-1.046.249-1.395-.149a16.57,16.57,0,0,1-2.665,4.35A3.734,3.734,0,0,1,61.343,79.509Z",
    transform: "translate(-26.393 -40.75)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M75.134,82.11c-.042,1.27.693,1.324.955,1.308a1.081,1.081,0,0,1-1.154-.212,15.674,15.674,0,0,1-3.321,5.023c-1.689,1.528-5.471,3.184-7.754,3.923a34.694,34.694,0,0,0,7.754-4.321C73.3,86.439,75.134,82.11,75.134,82.11Z",
    transform: "translate(-33.609 -48.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M57.446,66.324a8.5,8.5,0,0,0-1.806,1.59s.071-.137.187-.394l.1-.149-.137.245a6.973,6.973,0,0,1,1.291-1.44c.39-.237.934,0,1.2.672C58.11,66.589,57.778,66.224,57.446,66.324Z",
    transform: "translate(-12.388 -39.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M115.049,38.463a2.906,2.906,0,0,1,.457-.523,5.31,5.31,0,0,0-.3.98,32.883,32.883,0,0,1-1.1,4.566c-.27.573-.556,1.1-.751,1.536a20.347,20.347,0,0,1,.6-2.075C114.485,41.423,114.589,39.962,115.049,38.463Z",
    transform: "translate(-93.573 -22.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M56.248,74.3a1.577,1.577,0,0,0,.681-1.146c0-.332-.295-.863-.594-.415a1.78,1.78,0,0,1-.7.581,11.519,11.519,0,0,0,.963-1.689c.228-.415.959-1.428.959-1.428.531-.415,1-.415,1.328-.066s.2,2.038.17,2.461a3.848,3.848,0,0,1-.286,1.021,11.207,11.207,0,0,1-1.407,1.5C57.809,74.5,56.468,74.184,56.248,74.3Z",
    transform: "translate(-13.216 -41.452)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M57.273,70.2c.531-.415,1-.415,1.328-.066s.2,2.038.17,2.461a1.454,1.454,0,0,1-.054.274c-.029-.415-.1-1.274-.133-1.689a.926.926,0,0,0-.573-.83,1.577,1.577,0,0,0-.415.589c-.1.349.5,1.341.3,1.839a8.184,8.184,0,0,1-.83,1.345s.3-.648.415-.9.2-1.245-.1-1.49a.535.535,0,0,0-.627,0c-.145.32-.266.635-.349.863-.1-.046-.208,0-.315.141a1.916,1.916,0,0,1-.2.237h-.257c.291-.457.535-1.038.718-1.349A15.887,15.887,0,0,1,57.273,70.2Z",
    transform: "translate(-12.93 -41.452)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M99.308,70.537a.535.535,0,0,0-.071.2c0,.17.071.415.635.415a1.92,1.92,0,0,0,1.922-1.494,15.845,15.845,0,0,0,.731-5.172l-1.2-.1a19.016,19.016,0,0,1-.664,4.08,6.269,6.269,0,0,1-1.245,1.889Z",
    transform: "translate(-74.736 -38.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M102.329,76.961a1.668,1.668,0,0,0-1.789-.324l.2-.324a1.814,1.814,0,0,1,1.818.415Z",
    transform: "translate(-75.299 -45.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M103.22,77.282c0,.087.145.158.32.154s.315-.075.311-.162-.141-.158-.315-.154S103.22,77.194,103.22,77.282Z",
    transform: "translate(-77.709 -45.687)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M101.314,82.068l-.3-.025a2.519,2.519,0,0,0-1.54-.125c-1.092.149-1.889.473-2.735-.349l.523.9a9.521,9.521,0,0,0,1.565.722,15.777,15.777,0,0,0,2.076-.5l.448-.349Z",
    transform: "translate(-72.52 -48.29)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M106.744,83.375l-.581-.315a2.125,2.125,0,0,1-.232-1.029l.369.531Z",
    transform: "translate(-81.728 -48.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M101.309,82.644l-.274.2a2.433,2.433,0,0,0-1.245-.174,17.175,17.175,0,0,1-1.743.274,3.412,3.412,0,0,1-1.216-.473,1.528,1.528,0,0,0,.282.863,3.994,3.994,0,0,1,.531.481c.075.125.278,1.042,1.175,1.142a2.4,2.4,0,0,0,2.461-2.138Z",
    transform: "translate(-72.515 -48.816)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7,84.006a.594.594,0,0,1-.349.2.9.9,0,0,1-.461-.075S99.351,83.819,99.7,84.006Z",
    transform: "translate(-71.76 -49.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M97.126,72.513a9.58,9.58,0,0,1,.635-.789,4.866,4.866,0,0,0,.7-1.125,6.832,6.832,0,0,0,.565-2.74h0a6.492,6.492,0,0,1-1.337,4.209c-.361.444-.855.975-.731,1.6a1.934,1.934,0,0,0,.677.984,3.607,3.607,0,0,0,1.154.7.043.043,0,0,1-.025.083,3.362,3.362,0,0,1-1.814-1.37A1.357,1.357,0,0,1,97.126,72.513Zm2.972,2.021a.975.975,0,0,1,.714.154h0a1.291,1.291,0,0,0-1.316.2h0A1.764,1.764,0,0,1,100.1,74.535Zm1.27-.34a1.482,1.482,0,0,0-.091-.88h0c.208.494.32,1.478-.415,1.619,0,0-.046-.025-.025-.042a1.4,1.4,0,0,0,.54-.7Z",
    transform: "translate(-72.619 -40.271)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M81.4,59.038a4.6,4.6,0,0,0-2.208-1.345,5.89,5.89,0,0,0-3.8.457A4.533,4.533,0,0,1,74,58.3s.635-1.058,1.029-1.208S79.284,55.763,81.4,59.038Z",
    transform: "translate(-43.13 -33.782)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M102.57,56.014a3.566,3.566,0,0,1,2.046-1,4.182,4.182,0,0,1,3.072,1.225,3.142,3.142,0,0,0,1.125.415,4.9,4.9,0,0,0-.656-1.486A3.86,3.86,0,0,0,102.57,56.014Z",
    transform: "translate(-82.401 -32.347)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M104.64,40.11c.307-.415,1.839.552,2.96,1.374-.033.174-.066.345-.1.515a.334.334,0,0,1,0,.062l-.025.133a1.148,1.148,0,0,1-.042.208.684.684,0,0,0,0,.079,1.137,1.137,0,0,1-.041.2v.046a.974.974,0,0,1-.054.237v.062l-.062.245v.037l-.062.224v.046a.869.869,0,0,1-.071.245v.054c-.025.087-.054.17-.083.257s-.037.116-.058.17h0v.033h0l-.037.1h0v.046a.12.12,0,0,1-.029.1v.033h0v.033l-.025.087v.042h0V44.8l-.025.079a.5.5,0,0,0,0,.075.349.349,0,0,0,0,.071l-.025.075v.137a.408.408,0,0,0,0,.058.559.559,0,0,0,0,.079.23.23,0,0,1,0,.05.557.557,0,0,1-.021.079.146.146,0,0,0,0,.042l-.025.083v.033a.605.605,0,0,1,0,.083.1.1,0,0,1,0,.029.609.609,0,0,1-.021.083v.021a.119.119,0,0,1-.021.083h0v.083h0a.119.119,0,0,1-.021.083h0a6.972,6.972,0,0,0-.137.751,3.666,3.666,0,0,0,.257,1.66.585.585,0,0,0-.535.415,14.552,14.552,0,0,0,.12,2.955,5.322,5.322,0,0,0,.2.722l-.025.1a.49.49,0,0,1,0,.075v.448a1.046,1.046,0,0,1-.021.12.42.42,0,0,0,0,.066.373.373,0,0,1-.033.187c-.033.062,0,.033,0,.05v.345a.459.459,0,0,1,0,.075v.141a.377.377,0,0,1,0,.066v.208a10.487,10.487,0,0,0,1.586,5.774l.129.237v.033l.116.22a.249.249,0,0,1,0,.033c.046.083.091.166.133.253h0l.137.262h0a26.184,26.184,0,0,0,1.988,4.832A3.283,3.283,0,0,0,113.905,68c-.025.183-.054.369-.091.56h0a.276.276,0,0,1-.029.149h0a.266.266,0,0,1-.033.158c-1.112-.361-4.4-1.66-5.434-4.886,0,0-3.321-.6-3.736-5.521,0,0-3.894-1.864-4.628-7.609S104.2,40.7,104.64,40.11Z",
    transform: "translate(-86.377 -23.981)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M60.631,94.709v-.573h0V93.75h0v-.183a.083.083,0,0,0,0-.029l.025-.378v-.029c0-.129.021-.253.029-.382v-.428h0v-.191h0a2.673,2.673,0,0,1,.042-.361h0V91.6h0a3.562,3.562,0,0,1,.041-.361h0v-.174h0a2.663,2.663,0,0,1,.046-.365h0l.232-.627h0l.033-.191h0l.05-.357h0c.025-.174.05-.349.079-.519h0l.025-.166h0c.021-.112.037-.224.054-.336h0c.025-.166.054-.328.079-.486h0c.029-.158.054-.315.083-.469h0c.021-.1.037-.2.054-.3h0l.046-.075h0l.042-.071v-.025l.042-.066v-.025l.041-.071h0a.677.677,0,0,0,.042-.075h0l.178-.324h0l.037-.071h0a.45.45,0,0,0,.033-.062v-.021A.45.45,0,0,1,62,86.3h0l.033-.062h0l.033-.062h0L62.2,85.9h0l.025-.058h0l.025-.05h0v-.05h0a.226.226,0,0,1,0-.046h0a.225.225,0,0,1,.021-.046h0l.091-.2h0v-.033h0v-.029h0V85.37h0v-.025h0V85.32h0l.345-.419h0v-.037h0V84.83h0l.05.054h0l.05.046h0l.054.037h0l.054.033h0l.058.029h.27a.8.8,0,0,0,.141,0h.382l.353-.129H64.2a4.872,4.872,0,0,1,1.15,3.229,5.91,5.91,0,0,1-1.909,4.923c-.614.415-1.98,1.3-2.827,1.8a.794.794,0,0,1,0-.1Z",
    transform: "translate(-21.53 -50.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M116.148,63.977s-3.321-.6-3.736-5.521c0,0-3.894-1.864-4.628-7.609s4.251-10.145,4.691-10.738c.137-.183.506-.1.971.12.315.54.573,1,.573,1a8.236,8.236,0,0,0-2.146.922,3.882,3.882,0,0,0,1.245,3.7l-.291,1.42a6.338,6.338,0,0,1-1.37-4.865q-.241.162-.486.349c-.257,4.628,2.221,5.633,2.221,5.633l-.22,1.868c-2.864-2.291-2.594-5.961-2.42-7.152a7.513,7.513,0,0,0-1.316,1.532c-.444,1.507-1.548,6.729,3,10.02l.44,2.237s-5.1-3.121-4.271-10.547a9.053,9.053,0,0,0-.415,3.088c.149,6.787,5.218,8.206,5.218,8.206,0,4.774,3.234,5.741,3.234,5.741a8.769,8.769,0,0,0,2.046,3.848A6.808,6.808,0,0,1,116.148,63.977Z",
    transform: "translate(-94.211 -23.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M125.586,54.084l-.149.8s-1.909-1.146-1.909-5.321C123.527,49.56,123.871,52.943,125.586,54.084Zm-4.151-1.142c-.05,5.467,3.321,7.31,3.321,7.31l.174,1.44c-4.732-4.624-3.508-8.75-3.508-8.75Zm3.08-3.483a4.068,4.068,0,0,0,1.129,1.988l-.245.7A4.251,4.251,0,0,1,124.515,49.46Z",
    transform: "translate(-106.999 -29.509)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "M26.936,55.066c6.762-.668,7.642-5.591,7.642-5.591s1.1-7.384,1.029-7.609-.735-5.894-.9-6.118-1.4-7.758-.884-8.356a17.913,17.913,0,0,1,2.2-1.565c.22-.224,2.212.83,3.192,1.449a.239.239,0,0,0-.029-.1c-.075-.224,1.544-.83,3.321,1.789s6.542,8.352,7.057,11.934a3.8,3.8,0,0,1-.527,2.578,7.529,7.529,0,0,1,0,1.66,4.566,4.566,0,0,1-1.411,2.789,2.777,2.777,0,0,0,.971-.029c2.349-.448,2.864-2.686,2.129-4.4,0,0,1.839,2.387-.88,4.624a3.458,3.458,0,0,1-2.275.888,6.035,6.035,0,0,1,.087,4.2c-.531,1.619-2.582,2.129-3.366,2.266a9.352,9.352,0,0,1-2.441,1.689c2.2-1.806,2.935-5.957,2.935-5.957-1.175,5.446-6.392,7.982-6.392,7.982a8.617,8.617,0,0,0,2.354-5.371c-2.134,7.16-8.086,8.132-8.086,8.132l-.075-2.686a19.3,19.3,0,0,0,3.454-4.031,11.853,11.853,0,0,1-6.758,3.956,13.611,13.611,0,0,0,5.732-7.247,11.622,11.622,0,0,1-8.086,3.13ZM45.528,44.688c.058.112.108.228.162.34a4.971,4.971,0,0,0,2.4-2.208,7.8,7.8,0,0,0-3.018-2.756,34.87,34.87,0,0,0,.461,4.637ZM45.3,37.13a8.2,8.2,0,0,0-.166.934,6.948,6.948,0,0,1,3.051,2.8A9.492,9.492,0,0,0,45.3,37.142Zm3.1,7.177a7.779,7.779,0,0,1-2.345,1.611,12.665,12.665,0,0,1,.457,1.457,2.611,2.611,0,0,0,.332.257A4.786,4.786,0,0,0,48.408,44.307ZM44.735,55.032a2.708,2.708,0,0,0,2.271-1.905,3.8,3.8,0,0,0-.307-1.984,7.77,7.77,0,0,1-1.972,3.889Z",
    transform: "translate(6.466 -15.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M51.041,86.709s10-3.283,7.717-17.529c0,0,.83,10.22-8.011,15.591Z",
    transform: "translate(-11.172 -41.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M60.23,92.226a9.68,9.68,0,0,0,6.322-8.356l-1.914,1.494S62.584,90.528,60.23,92.226Z",
    transform: "translate(-22.565 -49.635)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M53,84.691a13.877,13.877,0,0,0,3.445-8.5s-1.025,2.536-1.764,3.055S54.764,82.08,53,84.691Z",
    transform: "translate(-9.458 -45.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M42.71,82.709s2.939-6.563,1.4-13.349l1.3,1.565a21.327,21.327,0,0,1-1.158,8.663s2.354-4.7,2.354-7.609l.585,2.686S46.388,80.418,42.71,82.709Z",
    transform: "translate(4.066 -41.148)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M42.493,63.346s1.689-3.582.955-6.783-1.909-4.848-2.574-7.235-2.129-7.978-2.129-7.978l3.674,3.5s-.22,6.185.735,9.09S45.947,59.24,42.493,63.346Z",
    transform: "translate(8.4 -24.765)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M34.818,54.323a4.226,4.226,0,0,0,.457-3.068,16.8,16.8,0,0,0-2.287-4.047L31.743,43.63s2.582,3.35,3.267,4.566S37.2,52.168,34.818,54.323Z",
    transform: "translate(19.699 -26.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "M33.338,78.49a3.981,3.981,0,0,1-3.038.332l.457.664A2.485,2.485,0,0,0,33.338,78.49Z",
    transform: "translate(23.072 -46.489)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "M36.073,82.41l-.457,1.424s.685,2.022.262,2.951a5.741,5.741,0,0,0,.2-4.375Z",
    transform: "translate(17.788 -48.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ba",
    d: "M53.55,76.164s6.513-4.176,6.907-8.9L58.1,65.87S58.3,72.287,53.55,76.164Z",
    transform: "translate(-13.698 -39.107)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bb",
    d: "M59.307,82.77s-1.519,7.011-7.057,9.962l.1.776S58.227,90.823,59.307,82.77Z",
    transform: "translate(-12.008 -48.992)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M59.653,95.58S57.4,99.66,55,100.852A7.668,7.668,0,0,0,59.653,95.58Z",
    transform: "translate(-13.496 -56.485)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd",
    d: "M66.455,88.16l-.735.3s-1.179,3.786-3.2,5.321C62.52,93.78,65.326,92.684,66.455,88.16Z",
    transform: "translate(-23.419 -52.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M58.663,69.409l-.49-.3A10.614,10.614,0,0,1,54.5,75.922,10.661,10.661,0,0,0,58.663,69.409Z",
    transform: "translate(-12.298 -41.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M47.98,72.338l-.49-.6a22.867,22.867,0,0,1-.071,6.666A16.892,16.892,0,0,0,47.98,72.338Z",
    transform: "translate(1.228 -42.54)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M46.609,80.37l.149.8s-.785,4.624-3.478,7.057A19.612,19.612,0,0,0,46.609,80.37Z",
    transform: "translate(4.264 -47.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bh",
    d: "M44.58,43.11l2.25,8.671a24.393,24.393,0,0,1-.1-6.766Z",
    transform: "translate(3.653 -25.794)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bi",
    d: "M57.675,66.2A14.27,14.27,0,0,1,56.5,70.424s.585-3.578.291-4.674Z",
    transform: "translate(-12.14 -39.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "M44.22,15.107c2.109-1.943,4.923-3.777,7.808-4.047,5.288-.519,12.15.311,16.658,5.168s6.272,11.834,6.272,11.834c-2.354-3.877-7.351-7.953-7.351-7.953s1.374,3.478,2.843,8.551a45.386,45.386,0,0,0,3.134,8.157,16.969,16.969,0,0,0-5.093-5.272,10.782,10.782,0,0,1-4.151-6.131c-.025-.112-.05-.22-.071-.332a3.349,3.349,0,0,0,.071.332c1.324,5.919,4.632,8.219,4.632,8.219l-2.158-.992-.685,2.188c-.88,6.463-5.292,8.65-5.292,8.65s2.171-1.49,2.752-5.467-1.274-5.969-1.274-5.969c-4.9-1.59-9.506-7.057-9.506-7.057a12.162,12.162,0,0,0,6.463,6.359,18.02,18.02,0,0,0-2.453-.631,13.054,13.054,0,0,1-3.429-4.043,15.2,15.2,0,0,0,2.4,3.86c-.78-.12-1.577-.216-2.358-.291A14.731,14.731,0,0,1,48.3,23.887a16.247,16.247,0,0,0,3.018,6.226c-.988-.05-1.876-.066-2.569-.058-.618-.523-1.49-1.66-2.017-4.151A7.548,7.548,0,0,0,48,30.084a10.792,10.792,0,0,1-2.623-.295A5.811,5.811,0,0,1,43.884,26.8a5.6,5.6,0,0,0,.552,2.756c-.892-.237-1.532-.469-1.532-.469C39.314,24.655,38.894,20.01,44.22,15.107Z",
    transform: "translate(-22.661 -6.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bk",
    d: "M68.692,21.858c4.508,4.873,6.272,11.834,6.272,11.834-2.354-3.877-7.351-7.953-7.351-7.953s1.374,3.478,2.843,8.551a45.387,45.387,0,0,0,3.134,8.157A16.969,16.969,0,0,0,68.5,37.174a10.782,10.782,0,0,1-4.151-6.131c-.025-.112-.05-.22-.071-.332a3.349,3.349,0,0,0,.071.332c1.324,5.919,4.632,8.219,4.632,8.219L66.82,38.27l-.685,2.188c-.88,6.463-5.292,8.65-5.292,8.65s2.171-1.49,2.752-5.467-1.274-5.969-1.274-5.969c-4.9-1.59-9.506-7.057-9.506-7.057a12.162,12.162,0,0,0,6.463,6.359,18.02,18.02,0,0,0-2.453-.631A13.054,13.054,0,0,1,53.4,32.3a15.2,15.2,0,0,0,2.4,3.86c-.78-.12-1.577-.216-2.358-.291A14.731,14.731,0,0,1,48.3,29.516a16.247,16.247,0,0,0,3.018,6.226c-.988-.05-1.876-.066-2.569-.058-.618-.523-1.49-1.66-2.017-4.151a7.548,7.548,0,0,0,1.274,4.18,10.792,10.792,0,0,1-2.623-.295A5.811,5.811,0,0,1,43.89,32.43a5.6,5.6,0,0,0,.552,2.756c-.892-.237-1.532-.469-1.532-.469C40.619,31.9,39.615,29,40.569,26a4.873,4.873,0,0,0,2.075,2.437,5.663,5.663,0,0,0,4.707.49c2.877-.8,4.388-1.287,7.127.125,1.793.926,3.644,2.491,5.811,1.868a6.339,6.339,0,0,0,3.321-2.96c.772-1.266.855-3.138,1.748-4.317.988-1.3,1.851.183,2.843-.415.664-.39-.054-1.627-.859-2.677A14.469,14.469,0,0,1,68.692,21.858Z",
    transform: "translate(-22.667 -12.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M87.971,14.8c-.7,0-2.848-.922-3.155.1s1.22,2.188.482,3.412c-.531.876-2,.2-2.872.083a2.175,2.175,0,0,0-1.793.382c-1.22.83-2.283,1.955-3.914,1.851s-2.1-1.1-3.254-2c-1.054-.83-1.723.12-2.7.6-1.125.552-2.075.253-2.3-1.137a8.575,8.575,0,0,0-.058-1.565A1.619,1.619,0,0,0,68,15.867c.249-.257.511-.511.789-.768,2.109-1.943,4.923-3.777,7.808-4.047a25.9,25.9,0,0,1,8.443.527C86.236,12.371,88.025,13.654,87.971,14.8Z",
    transform: "translate(-47.21 -6.965)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "M66.847,22.719a12.789,12.789,0,0,1-3.1-7.887s.237,4.67,5.164,8.692l.718.307s-3.254.639-7.546-2.345a7.79,7.79,0,0,1-3.595-7.858C58.375,20.05,65,22.233,66.847,22.719ZM74.053,14.7a4.091,4.091,0,0,1,.415.257ZM65.44,11.906A25.471,25.471,0,0,1,74.053,14.7c-.955-.535-3.62-1.772-8.8-2.349,5.9,2.287,6.579,5.757,6.579,5.757-1.619-2.781-7.534-3.827-7.534-3.827a15.467,15.467,0,0,1,6.015,1.739c-1.328-1.943-5.114-3.566-6.6-4.151l-.859-.274a21.962,21.962,0,0,1,12.038,1.868l-.955.3S69.748,11.3,65.44,11.906ZM58.3,13.388c-3.823,2.76-3.823,4.7-3.823,4.7V16.148A11.041,11.041,0,0,1,58.3,13.388Zm6.226,9.771s4.944,7.177,11.556,9.174c0,0-8.451-1.938-13.009-9.7Zm11.041-2.013s.83,7.31,5.438,11.037A17.068,17.068,0,0,1,74.538,21.59ZM51.978,21l.955,1.038a7.379,7.379,0,0,0,.369,5.894A8.248,8.248,0,0,1,51.978,21Zm4.483,1.938a12.773,12.773,0,0,0-.365,5.894,7.422,7.422,0,0,1-.519-5.745Zm7.351,6.413a11.539,11.539,0,0,1-4.338-6.861l.955-.452C60.355,26.069,63.812,29.348,63.812,29.348Zm7.347-6.641.66.523a26.615,26.615,0,0,0,3.163,6.712,17.792,17.792,0,0,1-3.823-7.231ZM76.3,20.473l.664-.374s1.909,1.49,2.719,5.811A10.918,10.918,0,0,0,76.3,20.473ZM64.838,21.59l-1.025-.224c-4.778-3.055-2.354-9.024-2.354-9.024C59.475,19.278,64.838,21.59,64.838,21.59Z",
    transform: "translate(-33.495 -7.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bm",
    d: "M68.693,16.211c4.508,4.873,6.272,11.834,6.272,11.834-2.354-3.877-7.351-7.953-7.351-7.953s1.374,3.478,2.843,8.551A45.385,45.385,0,0,0,73.591,36.8,16.969,16.969,0,0,0,68.5,31.528,10.782,10.782,0,0,1,64.347,25.4c-.025-.112-.05-.22-.071-.332a3.349,3.349,0,0,0,.071.332c1.324,5.919,4.632,8.219,4.632,8.219l-2.158-.992-.685,2.188c-.88,6.463-5.292,8.65-5.292,8.65S63.015,41.972,63.6,38s-1.274-5.969-1.274-5.969c-4.9-1.59-9.506-7.057-9.506-7.057a12.162,12.162,0,0,0,6.463,6.359,18.021,18.021,0,0,0-2.453-.631A13.054,13.054,0,0,1,53.4,26.655a15.2,15.2,0,0,0,2.4,3.86c-.78-.12-1.577-.216-2.358-.291A14.731,14.731,0,0,1,48.3,23.869,16.247,16.247,0,0,0,51.321,30.1c-.988-.05-1.876-.066-2.569-.058-.618-.523-1.49-1.66-2.017-4.151a7.548,7.548,0,0,0,1.274,4.18,10.793,10.793,0,0,1-2.623-.295,5.811,5.811,0,0,1-1.494-2.989,5.6,5.6,0,0,0,.552,2.756c-.892-.237-1.532-.469-1.532-.469-3.42-4.2-3.968-8.588.552-13.221a10.255,10.255,0,0,1-.7.917c-5.072,6.193.145,11.789.145,11.789l.83.295A10.522,10.522,0,0,1,46.087,19.3c-4.039,6.343-.585,10.07-.585,10.07l1.909.3a7.634,7.634,0,0,1-.66-6.044c0,4.255,1.909,5.894,1.909,5.894h1.752c-3.454-4.475-2.719-10.294-2.719-10.294.589,7.982,5.878,10.518,5.878,10.518l.83-.075L53.007,26.24a23.423,23.423,0,0,1-2.154-5.1c-4.7-3.952-3.159-7.679-3.159-7.679a7.629,7.629,0,0,0,2.424,6.488c3.088,2.985,7.862,3.445,7.862,3.445a13.873,13.873,0,0,1-4.566-6.716,15.624,15.624,0,0,0,6.04,7.3c-5.512-.3-8.161-2.686-8.161-2.686,2.868,5.6,5.438,6.716,8.817,8.879A13.1,13.1,0,0,0,66.8,32.242a21.316,21.316,0,0,1-1.764-3.283,29.857,29.857,0,0,1-1.6-7.073,24.669,24.669,0,0,0,3.894,7.907,10.523,10.523,0,0,0,4.325,3.433A41.265,41.265,0,0,1,69,24.945c-.88-4.475-4.848-8.3-4.848-8.3s6.023,4.944,8.3,7.164c.166.162.32.324.465.486-.336-1.175-2.424-7.621-8.621-11-4.566-2.491-9.78-2.491-12.743-2.212l.477-.058C57.324,10.524,64.185,11.354,68.693,16.211Z",
    transform: "translate(-22.668 -6.952)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bn",
    d: "M61.362,71.37s2.163-1.49,2.744-5.467-1.274-5.969-1.274-5.969A14.324,14.324,0,0,1,60,58.61a30.074,30.074,0,0,0,7.26,2.134l-.618,1.976C65.774,69.182,61.362,71.37,61.362,71.37Z",
    transform: "translate(-23.178 -34.861)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bo",
    d: "M75.079,21.269c.481-.884.228-2.32,1.341-2.7.444-.149,1.183.137,1.561-.112.581-.382.133-1.058-.311-1.436l-.735-.668c1.025.706,2.03,1.366,3,2.163.9.743,1.594,1.681,2.416,2.491-.83-.374-1.523-.892-2.4-1.2-.635-.224-1.972-1-2.644-.618-1.283.718,1.154,2.333.145,2.7-.589.22-1.42-.145-2.075,0a2.283,2.283,0,0,0-1.436,1.034,13.356,13.356,0,0,0-1.212,3.4,14.749,14.749,0,0,0-1.739-1.972,7.077,7.077,0,0,0-1.469-1.378C71.16,21.738,73.842,23.548,75.079,21.269ZM61.958,22.846c.257-.145,1.752,1.366,1.972,1.623l.075.606a3.6,3.6,0,0,0-1.768.274C62.074,25.092,61.63,23.041,61.958,22.846Zm-1.905.506c.577-.3.556-.149.643.448a7.658,7.658,0,0,1,.071,1.714v.448a3.553,3.553,0,0,0-2.432-.029,5.223,5.223,0,0,1,1.718-2.574ZM55.4,21.543a16.238,16.238,0,0,1,1.37-1.9c-.282.975-.133,3.341,1.27,3.346.1.8-.751,1.586-.726,2.3l-.071.374c-.2-1.058-1.054-3.591-2.432-1.893a11.84,11.84,0,0,1,.589-2.221Z",
    transform: "translate(-36.111 -10.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bp",
    d: "M64.725,63.861a11.642,11.642,0,0,1-.22,6.861s1.764-2.013,1.4-6.936l-1.544-.9Z",
    transform: "translate(-23.682 -37.364)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bq",
    d: "M81.833,66.283a2.688,2.688,0,0,0-2.171-2.075,4.819,4.819,0,0,0-1.631-.17,3.669,3.669,0,0,0-2.017.83h0a3.736,3.736,0,0,1,2.017-.888,5.326,5.326,0,0,1,1.66.137,3.533,3.533,0,0,1,1.478.76,2.009,2.009,0,0,1,.664,1.407Z",
    transform: "translate(-44.392 -37.992)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.991,65.251a3.906,3.906,0,0,1,2.6-.988,1.337,1.337,0,0,0,0-.573,1.034,1.034,0,0,1,.129.581,3.372,3.372,0,0,1,.415.054,2.968,2.968,0,0,1,.76.249,1.386,1.386,0,0,0,.2-.6.984.984,0,0,1-.071.664,2.544,2.544,0,0,1,.768.606,1.3,1.3,0,0,0,.83-.573,1.245,1.245,0,0,1-.693.751,2.574,2.574,0,0,1,.34.664,1.544,1.544,0,0,0,.892-.444,1.378,1.378,0,0,1-.863.664c-1.8,1.855-4.865.5-4.865.5L74.7,66.176C75.356,66.056,75.7,65.446,75.991,65.251Z",
    transform: "translate(-44.179 -37.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M83.708,67.6c-1.059,1.353-3.736.726-5.164.133l-1-.353c1.2-.332,1.926-1.469,3.346-1.577a2.707,2.707,0,0,1,2.96,1.66Z",
    transform: "translate(-47.044 -39.065)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "br",
    d: "M79.667,66.908a1.353,1.353,0,0,1,.506-.917,2.389,2.389,0,0,1,.581-.145,2.6,2.6,0,0,1,1.432.241,1.349,1.349,0,0,1,.415,1.121,1.411,1.411,0,0,1-1.245,1.245,3.88,3.88,0,0,1-.535-.025,1.428,1.428,0,0,1-1.154-1.519Z",
    transform: "translate(-46.689 -39.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bs",
    d: "M82.658,67.19a1.312,1.312,0,0,1-2.6-.266,1.245,1.245,0,0,1,1.121-1.088,2.632,2.632,0,0,1,.448,0A1.245,1.245,0,0,1,82.658,67.19Z",
    transform: "translate(-46.907 -39.082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.365,67.686a.772.772,0,1,0,.83-.643A.747.747,0,0,0,81.365,67.686Z",
    transform: "translate(-47.681 -39.789)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bt",
    d: "M81.912,68.01a.544.544,0,1,0,.594-.457.527.527,0,0,0-.594.457Z",
    transform: "translate(-48.004 -40.089)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M82.295,66.891a.32.32,0,1,0,.349-.266.307.307,0,0,0-.349.266Z",
    transform: "translate(-48.1 -39.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M83.01,70.277a.152.152,0,1,0,.166-.129A.15.15,0,0,0,83.01,70.277Z",
    transform: "translate(-48.782 -41.609)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.525,67.3c1.224-.415,1.992-1.548,3.408-1.627a3.379,3.379,0,0,1,1.872.415A2.515,2.515,0,0,1,83.842,67.4a2.644,2.644,0,0,0-1.1-1.245,3.3,3.3,0,0,0-1.984-.353c-1.32.133-2.013,1.22-3.234,1.515C77.52,67.308,77.516,67.3,77.525,67.3Zm3.661,1.017a.041.041,0,0,1,.042,0,.046.046,0,0,1,.037.029,2.823,2.823,0,0,0,2.428-.8h0a2.74,2.74,0,0,1-2.437.83.078.078,0,0,1-.083-.025,8.942,8.942,0,0,1-2.648-.685h0A8.941,8.941,0,0,0,81.186,68.313Z",
    transform: "translate(-47.033 -38.984)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bq",
    d: "M104.5,62.942a2.374,2.374,0,0,1,2.129-1.623,3.354,3.354,0,0,1,1.345.129,2.943,2.943,0,0,1,1.478,1.162h0a3.009,3.009,0,0,0-1.44-1.212,3.632,3.632,0,0,0-1.382-.17,2.665,2.665,0,0,0-1.328.465,2.076,2.076,0,0,0-.789,1.245Z",
    transform: "translate(-83.857 -36.386)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.068,63.016a3.11,3.11,0,0,0-1.922-1.42,1.66,1.66,0,0,1,.1-.556,1.108,1.108,0,0,0-.208.535,2.447,2.447,0,0,0-.357-.025,2.038,2.038,0,0,0-.66.1,1.58,1.58,0,0,1-.054-.61,1.117,1.117,0,0,0-.058.648,2.162,2.162,0,0,0-.7.457,1.179,1.179,0,0,1-.565-.71,1.216,1.216,0,0,0,.415.83,2.861,2.861,0,0,0-.415.581,1.328,1.328,0,0,1-.623-.581,1.266,1.266,0,0,0,.577.78c1.117,2.129,3.835,1.37,3.835,1.37l1.507-.291C108.433,63.929,108.271,63.261,108.068,63.016Z",
    transform: "translate(-82.714 -36.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M103.12,64.365c.61,1.494,2.906,1.378,4.151,1.063l.83-.162c-.909-.535-1.291-1.76-2.416-2.121A2.121,2.121,0,0,0,103,64.207Z",
    transform: "translate(-81.868 -37.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bu",
    d: "M105.365,64.221a1.366,1.366,0,0,1,.83-1.121,2.175,2.175,0,0,1,.639.116,2.976,2.976,0,0,1,1.287,1.245.117.117,0,0,0,0,.037,1.37,1.37,0,0,1-1,1.179,4.248,4.248,0,0,1-.689,0A1.37,1.37,0,0,1,105.365,64.221Z",
    transform: "translate(-82.868 -37.487)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bv",
    d: "M106.843,65.608a1.208,1.208,0,0,1,0-2.408l.224.062a2.49,2.49,0,0,1,1.125,1.013,1.3,1.3,0,0,1,0,.253,1.216,1.216,0,0,1-1.349,1.079Z",
    transform: "translate(-83.1 -37.545)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.925,65.082a.724.724,0,1,0,.793-.648A.724.724,0,0,0,106.925,65.082Z",
    transform: "translate(-83.763 -38.265)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bw",
    d: "M107.458,65.354a.506.506,0,1,0,.552-.456A.5.5,0,0,0,107.458,65.354Z",
    transform: "translate(-84.085 -38.537)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M107.816,64.269a.295.295,0,1,0,.324-.262.295.295,0,0,0-.324.262Z",
    transform: "translate(-84.169 -38.017)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M108.489,67.593a.144.144,0,1,0,.158-.125.141.141,0,0,0-.158.125Z",
    transform: "translate(-84.821 -40.041)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.11,65.211c-.913-.619-1.324-1.851-2.453-2.183a2.354,2.354,0,0,0-1.582.046A2.316,2.316,0,0,0,103,64.153h0a2.37,2.37,0,0,1,1.108-1,2.312,2.312,0,0,1,1.66,0c1.042.365,1.4,1.54,2.333,2.042Zm-3.134.32a.042.042,0,0,0-.033-.029.033.033,0,0,0-.033,0,2.2,2.2,0,0,1-1.781-1.187h0a2.141,2.141,0,0,0,1.814,1.245l.033.025a.041.041,0,0,0,.033,0,6.284,6.284,0,0,0,2.262-.183h0a6.389,6.389,0,0,1-2.275.129Z",
    transform: "translate(-81.877 -37.377)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M98.377,64.643S97.871,63.132,97,63.049s-1.482.892-1.793,1.565l.365-2.632L95.268,60.5a2.919,2.919,0,0,0,1.66,1.2,2.676,2.676,0,0,0,1.905-.83L98.8,61.965Z",
    transform: "translate(-69.367 -35.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M98.535,65.006l.295-1.872v-.556a2.632,2.632,0,0,1-1.445.556,1.374,1.374,0,0,1-.228,0,2.354,2.354,0,0,1-1.2-.614l.125.614a.171.171,0,0,1,0,.079L95.87,64.72a1.718,1.718,0,0,1,1.3-.718h.129a1.81,1.81,0,0,1,1.245,1.017Z",
    transform: "translate(-69.637 -37.148)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M68.172,60.55c.465-1.216,2.229-1.66,5.421-1.66a19.41,19.41,0,0,1,5.882.967c.672,1.133.627,4.118-.212,6.343s-3.109,2.146-5.4,2.146-4.118-.589-5.043-2.491A7.51,7.51,0,0,1,68.172,60.55ZM69,65.258c.809,2.52,4.172,2.727,5.927,2.686a3.822,3.822,0,0,0,3.653-3.653,10.792,10.792,0,0,0-.166-3.781,9.1,9.1,0,0,0-4.832-1.133c-2.814.125-4.371.5-4.707,1.175s-.664,2.183.137,4.707Z",
    transform: "translate(-39.149 -35.024)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M76.024,68.483c1.627-.1,2.814-.482,3.371-1.959.83-2.192.83-5.006.27-6.064a19.447,19.447,0,0,0-3.615-.789A8.746,8.746,0,0,1,78.9,60.692a.262.262,0,0,1,.1.137,11.029,11.029,0,0,1,.174,3.889,4.454,4.454,0,0,1-1.332,2.827,3.848,3.848,0,0,1-1.826.955Zm-2.765,0a6.227,6.227,0,0,1-2.789-.975,5.122,5.122,0,0,0,2.789.946Zm-4.342-3.557a5.982,5.982,0,0,1,.112-4.085C69.4,60.1,70.818,59.7,73.6,59.55c-3.022.029-4.483.477-4.865,1.482a6.522,6.522,0,0,0,.166,3.894Z",
    transform: "translate(-39.505 -35.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M113.025,58.8c-.241-1.278-1.71-1.93-4.5-2.345a14.6,14.6,0,0,0-5.272.228c-.664,1.079-.793,4.064-.2,6.305.581,2.167,2.491,2.337,4.354,2.578s3.433-.1,4.4-1.723A8.432,8.432,0,0,0,113.025,58.8Zm-1.274,4.441c-.938,2.229-3.736,2.075-5.168,1.835s-2.756-1.623-2.827-3.86a11.934,11.934,0,0,1,.415-3.736,6.87,6.87,0,0,1,4.334-.54c2.432.49,3.736,1.071,3.931,1.785A7.242,7.242,0,0,1,111.751,63.24Z",
    transform: "translate(-86.717 -33.517)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M106.2,65.477a2.936,2.936,0,0,1-2.706-2.2c-.585-2.208-.415-5.01.133-6.027a14.976,14.976,0,0,1,3.258-.345,6.559,6.559,0,0,0-2.6.685.216.216,0,0,0-.1.125,12.146,12.146,0,0,0-.415,3.84,4.744,4.744,0,0,0,.967,2.86A3.412,3.412,0,0,0,106.2,65.5Zm2.283.286a4.777,4.777,0,0,0,2.391-.585A3.922,3.922,0,0,1,108.479,65.764Zm3.964-2.814a6.9,6.9,0,0,0,.415-3.968c-.224-.789-1.4-1.378-3.815-1.889,2.623.415,3.827,1.058,4.026,2.113a7.072,7.072,0,0,1-.61,3.736Z",
    transform: "translate(-86.949 -33.866)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bx",
    d: "M99.071,92.442a6.6,6.6,0,0,1-3.184,1.748s-2.042.415-3.022-.581a5.142,5.142,0,0,1-.726-1.1,4.757,4.757,0,0,0-.689-1.058s.946.27,1.108.282l2.524.178c.162,0,2.291.083,2.291.083Z",
    transform: "translate(-68.044 -54.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "by",
    d: "M92.554,91.742l2.524.178c.162,0,2.291.083,2.291.083l1.7.444a4.66,4.66,0,0,1-.5.448h0s-5.135-.091-6.641-.78a5.27,5.27,0,0,0-.477-.656S92.392,91.73,92.554,91.742Zm4.358,2.121h0a6.422,6.422,0,0,1-1.034.324s-2.042.415-3.022-.581a6.283,6.283,0,0,1-.519-.71,2.539,2.539,0,0,1,.232.208C93.97,94.461,96.913,93.863,96.913,93.863Z",
    transform: "translate(-68.04 -54.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bz",
    d: "M100.558,95.285a18.008,18.008,0,0,0-2.681-.415,8.835,8.835,0,0,0-1.876,0,2.877,2.877,0,0,0,1.992.855,5.811,5.811,0,0,0,2.565-.44Z",
    transform: "translate(-71.419 -56.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "by",
    d: "M89.679,90.454A1.689,1.689,0,0,1,90.787,90a1.524,1.524,0,0,1,1.038.5,3.657,3.657,0,0,1,1.839-.208c.955.178,1.938.677,2.727.9a1.594,1.594,0,0,0,1.428-.415,2.578,2.578,0,0,1-1.449.764c-1.245,0-2.453-.228-3.686-.266h0l-.05.05a4.438,4.438,0,0,1-.83.158,4.361,4.361,0,0,1-.444-.2h-.133a14.224,14.224,0,0,0-1.66-.361c-.519-.174-.83-.71-1.117-1.125C88.438,89.777,89.4,90.649,89.679,90.454Z",
    transform: "translate(-65.546 -53.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ca",
    d: "M92.7,91.2a27.946,27.946,0,0,1,2.823.191c.237,0,.473.025.71.029a1.476,1.476,0,0,0,.27,0,1.111,1.111,0,0,0,.295-.079,2.465,2.465,0,0,0,1.034-.631h0a2.312,2.312,0,0,1-.863.6l-.232.079c-.1.029-.253.041-.324.116s-.158.021-.2.021h-.415a13.2,13.2,0,0,1-1.565-.141c-.519-.062-1.046-.1-1.569-.158Zm-1.718-.249s0-.058.033-.037a2.718,2.718,0,0,0,.7.415,1.457,1.457,0,0,0,.926-.071h0a3.821,3.821,0,0,1-.523.12c-.187.029-.266.083-.436,0a1.478,1.478,0,0,1-.718-.428Zm-2.507-1.22A2.86,2.86,0,0,0,89.543,90.8c.548.232,1.166.178,1.718.415h0a3.492,3.492,0,0,0-.984-.2,2.491,2.491,0,0,1-.83-.162,2.677,2.677,0,0,1-.988-1.125S88.472,89.724,88.472,89.732Z",
    transform: "translate(-65.56 -53.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M38.077,115.118c-.573,1.337-.17,2.993-.037,4.371,0,.025.046.025.046,0-.062-1.449.315-2.868.353-4.3.457.091.975.482,1.449.594-.262,2.491-.8,4.8.415,7.057a4.819,4.819,0,0,0,4.462,2.823c5.272-.336,8.235-5.135,9.8-9.883.589,0,1.445-.311,2.034-.32a15.2,15.2,0,0,1-3.653,7.322c0,.021,0,.05.033.033a13.071,13.071,0,0,0,4.08-7.355,16.257,16.257,0,0,1,7.177,1.154c3.478,1.66,5.712,4.566,8.235,7.235.386.5.8.98,1.212,1.457a27.216,27.216,0,0,0-2.96,3.57,29.53,29.53,0,0,0-2.769,4.52l-.345.735c-.116.249-.241.494-.353.747-.257-.208-.552-.369-.83-.594-.436-.324-.851-.668-1.245-1.021l-.353-.311-.3-.27a14.669,14.669,0,0,0-2.993-2.491h0a12.893,12.893,0,0,0,2.906,3.234l.062.054a15.2,15.2,0,0,0-1.532,3.769l-.183.693c-.415,1.64-.664,3.321-.884,4.757a23.028,23.028,0,0,0,.544,10.672c-.934,1.013-1.885,2.009-2.864,2.985-1.519-.465-3.072-.83-4.566-1.332-1.316-.415-2.623-.863-3.952-1.212l-1.013.228c-2.6.6-8.032,2.906-5.9,5.292a3.321,3.321,0,0,0,.262,1.636,3.17,3.17,0,0,0,1.445,1.436c-.295.61-.2,1.9.527,2.1a.133.133,0,0,0,.166-.087,1.349,1.349,0,0,0,.178.075,1.661,1.661,0,0,0-.112.83c.066.382.262.8.689.776,1.357,1.162,4.1,1.017,5.674.631h0l-.137-.025a15.488,15.488,0,0,0,4.948-2.2,51.427,51.427,0,0,0,4.587-2.968c.486-.228.971-.469,1.453-.714.108.27.216.54.307.83.22.656.444,1.312.706,1.951A10.946,10.946,0,0,1,63.8,164.61l-.5.415c-3.487,2.657-8.821,3.865-12.652,4.213a37.955,37.955,0,0,1-12.6-1.216l-.863-.22h-.042c1.083-3.761-.191-8.518-1.1-12.038-.648-2.524-.627-6.019-2.158-8.3a.05.05,0,0,0,0-.058c-.88-1.54-2.6-2.1-3.827-3.3l-.336-.357c-.071-.087-.141-.174-.208-.266a8.738,8.738,0,0,1-1.432-5.683c.772-1.573,1.449-3.2,2.208-4.782l.154-.324c.9-1.826,2.038-3.761,2.325-5.782a.029.029,0,0,0-.05-.021,12.188,12.188,0,0,0-.7,1.017,10.469,10.469,0,0,0-.369-2.453,23.659,23.659,0,0,0-1.42-4.491.058.058,0,0,0-.112,0,12.828,12.828,0,0,0,.726,4.026,16.915,16.915,0,0,1,.415,4.288c-.511,1.029-.971,2.075-1.453,3.092a42.524,42.524,0,0,1-5.189-2.358c.228-1.245.44-2.491.606-3.765,1.308-3.831,1.685-12.038,7.256-11.884A34.773,34.773,0,0,1,38.077,115.118Z",
    transform: "translate(-14.92 -67.472)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cb",
    d: "M31.82,156.06a8.677,8.677,0,0,0,1.432,5.583c.066.091.137.178.208.266l.336.357c1.245,1.2,2.951,1.756,3.827,3.3a.05.05,0,0,1,0,.058,8.276,8.276,0,0,1,1.063,2.49,4.437,4.437,0,0,1,2.258-.83,45.738,45.738,0,0,1,17.114,1.133,5.6,5.6,0,0,1,1.814.718,5.443,5.443,0,0,1,1.839,3.18c.174.648.324,1.3.452,1.959.365.1,1.44,6.94,1.8,7.057.984-.971,2.673-1.291,3.607-2.3-1.129-3.4-2.532-14.586-1.992-18.085.224-1.449.477-3.117.884-4.757l.183-.693a19.093,19.093,0,0,1,.66-1.98h0a12.315,12.315,0,0,1,.872-1.789l-.062-.054a13.726,13.726,0,0,1-2.906-3.234h0a13.423,13.423,0,0,1,2.993,2.491l.307.27.349.311c.415.353.83.7,1.245,1.021.3.224.594.386.855.594.108-.253.232-.5.349-.747l.345-.735a29.192,29.192,0,0,1,2.727-4.454,3.254,3.254,0,0,1-2.968,1.3,9.5,9.5,0,0,1-3.354-1.7,9.58,9.58,0,0,0-3.972-1.291,21.56,21.56,0,0,0,.336,5.541,26.473,26.473,0,0,1-.6,4.072,7.709,7.709,0,0,1-1.635,3.628,7.188,7.188,0,0,1-4.342,1.884,17.5,17.5,0,0,1-7.679-.664c-2.1-.677-4.151-1.764-6.355-1.739-3.1.029-6.322,2.221-9.074.8A12.9,12.9,0,0,1,31.82,156.06Zm28.737,27.695a7.333,7.333,0,0,0,1.3-1.3,42.709,42.709,0,0,0,4.354-2.536,5.445,5.445,0,0,0,.942-.544c.141-.108.249-.282.415-.361.108.27.216.54.307.83.224.656.444,1.312.706,1.951A10.483,10.483,0,0,1,67.53,182.8l-.5.415c-3.271,2.491-8.161,3.711-11.917,4.151a31.926,31.926,0,0,0,5.442-3.615Z",
    transform: "translate(-18.6 -85.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M198.23,131.48v.021a1.81,1.81,0,0,0,.652,1.66,3.186,3.186,0,0,0,.739.378,1.316,1.316,0,0,1-.49.731,3.6,3.6,0,0,1-.963.162.148.148,0,0,0-.062.033,2.408,2.408,0,0,0-.54-.66,5.117,5.117,0,0,0-1.611-1.079,5.374,5.374,0,0,0-2.785-.668,5.742,5.742,0,0,1,.278-1.44,2.822,2.822,0,0,1,.552-.83c1.088-.34,1.98.307,2.906.8A5.492,5.492,0,0,1,198.23,131.48Z",
    transform: "translate(-210.816 -76.437)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M202.034,138.245a1.482,1.482,0,0,1,.6.859.9.9,0,0,1-.627,1.058,6.658,6.658,0,0,1-2.158.212l-.315-.154a7.685,7.685,0,0,0-2.208-.805h-.286a2.274,2.274,0,0,1-.249-1,2.491,2.491,0,0,1,.83-2c.863.332,1.826.415,2.694.78A18.213,18.213,0,0,1,202.034,138.245Z",
    transform: "translate(-215.354 -80.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M191.27,127.581l-.44.087-.046.253a4.57,4.57,0,0,0-1.76-1.278,5.62,5.62,0,0,0-1.494-.6.275.275,0,0,0,.046-.116,2.428,2.428,0,0,1,.764-1.245c.075-.075.158-.141.237-.212a3.649,3.649,0,0,1,2.279-.075,12.888,12.888,0,0,1,1.548.585c.971.452,2.034.789,2.046,2.013-.855.12-1.7.295-2.545.486C191.7,127.51,191.486,127.543,191.27,127.581Z",
    transform: "translate(-203.304 -73.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cb",
    d: "M49.325,155.008l-.573.369-3.362-2.594V151.77h1.3Z",
    transform: "translate(0.821 -89.351)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cc",
    d: "M141.306,182.18l-.477.756a16.778,16.778,0,0,0,2.906,1.536s.108,0,.058-.083A12.294,12.294,0,0,0,141.306,182.18Z",
    transform: "translate(-133.274 -107.138)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M110.17,116.257l-.44-.087-.158.2-.183.859v3.018l.2.39.382.1.149-2.026Z",
    transform: "translate(-86.59 -68.528)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M68.482,116.98l-.49.008-.469,1.054-1.312,3.184-1.806,2.457-.216.66.506.2,1.274-1.3,1.656-2.852,1-3.1Z",
    transform: "translate(-26.289 -69.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cc",
    d: "M21.58,174.533l.212.286,1.337-1.079h0A6.559,6.559,0,0,0,21.58,174.533Z",
    transform: "translate(36.902 -102.201)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M29.93,141.25c1.631,1.822,3.275,3.541,4.815,5.4.345.415.677.851,1,1.278l.66.884c1.117,1.544,2.129,3.138,3.121,4.765a16.57,16.57,0,0,1,.772,2.308,7.339,7.339,0,0,1-.278,3.292,43.8,43.8,0,0,1-4.819,4.67c-1.88,1.66-3.682,3.4-5.678,4.935-3.1,2.379-6.43,4.408-9.667,6.583l-.515.349q-.668.448-1.32.909a46.637,46.637,0,0,0-4.786,2.906,41.36,41.36,0,0,1-5.023,2.686c-.751-.129-1.5-.187-2.266-.295a28.751,28.751,0,0,1-2.839-.739.414.414,0,0,0-.1,0,1.54,1.54,0,0,1-.2-.531,4.24,4.24,0,0,1,0-.44,6.861,6.861,0,0,0,1.017.108,14.424,14.424,0,0,0,2.2-.12v-.021a14.694,14.694,0,0,0-2.171-.3,12.659,12.659,0,0,0-1.731-.291,2.848,2.848,0,0,1-.216-.606c-.042-.291,0-.594-.046-.88a4.684,4.684,0,0,0,1,.125,28.071,28.071,0,0,0,3.242-.365c.025,0,0-.042,0-.046-.971-.091-1.922-.05-2.906-.1a4.337,4.337,0,0,1-1.627-.286c-.34-.166-.374-.241-.581-.266a9.3,9.3,0,0,1-.461-1.171c-.075-.224-.129-.486-.216-.726a3.62,3.62,0,0,0,2.15-.245c.49-.162.959-.349,1.436-.54a5.988,5.988,0,0,1,1.411-.56c.029,0,0-.046,0-.046a11.27,11.27,0,0,0-2.466.49c-.751.245-1.814.7-2.578.307a.2.2,0,0,0-.237.029,2.341,2.341,0,0,1,1.141-2.316,16.681,16.681,0,0,1,2.258-1.245c.909-.415,1.909-.76,2.785-1.245a39.435,39.435,0,0,0,8.406,2.756l.755.129.648-.544c.855-.735,1.66-1.511,2.449-2.32l.469-.531c1.349-1.432,2.611-2.955,3.819-4.512,1.407-1.814,2.711-3.736,4.151-5.566l.357-.44a27.218,27.218,0,0,1,2.491-2.723l.357-.332a14.294,14.294,0,0,1,1.3-1.054h0a8.54,8.54,0,0,0-1.532.8c-1.154-1.274-2.308-2.549-3.524-3.765-.357-.357-1.2-1.274-2.1-2.163a32.106,32.106,0,0,1,2.42-4.358,50.683,50.683,0,0,1,3.238-4.01Z",
    transform: "translate(28.602 -83.197)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cb",
    d: "M126.156,136.1a6.135,6.135,0,0,0-.672,1.025,16.985,16.985,0,0,0-1.5-6.3l-.266-.6s-.125-.262-.137,0a5.157,5.157,0,0,0,.374,2.657s.772,4.479.772,4.948v-.469l-.046,1.129-1.461,3.072.681.282c.05,0,2.561-4.732,2.308-5.7,0,0,.033-.1,0-.112S126.185,136.046,126.156,136.1Z",
    transform: "translate(-108.382 -76.682)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaisIcon);
export default __webpack_public_path__ + "static/media/lais-icon.7d3b992bc58a7bbb26fcdf9637e9b7f2.svg";
export { ForwardRef as ReactComponent };